import { BaseComponent } from './BaseComponent';
export class UnknownComponent extends BaseComponent {
    constructor(compRef, unknownCompType) {
        super(compRef);
        this.unknownCompType = unknownCompType;
        this.type = 'unknown';
    }
}
//# sourceMappingURL=UnknownComponent.js.map